<template>
  <div id="landing">
    
    <div class="landing-content">
      <div class="title">South London Canada Day</div>
      <div class="subtitle">
        Wednesday July 1, 2026
      </div>
      <div class="text">
        <!-- If you or someone you know would like to sponsor the event,
        click the link below to download the 2026 Sponsorship Package.
        <br><br> -->
        If you are interested in joining or committee or volunteering on Canada Day 
        Please contact Chris Ewer at 519-859-2859 or email cewer@rogers.com
        <!-- <br><br>
        South London Canada Day is in desperate need of donations
        We now can accept donations through e=transfer to southlondoncanadaday@rogers.com -->
      </div>
      <div class="downloads">
        <a href="../assets/CanadaDay2026Flyer.pdf" target="_blank">Download 2026 Flyer</a>
        <a href="../assets/CanadaDay2026Sponsorship.pdf" target="_blank">Download 2026 Sponsorship Package</a>
        <a href="../assets/CanadaDay2026Volunteer.pdf" target="_blank">Download 2026 Volunteer Application</a>
      </div>
      <div class="tags">
        <ul>
          <li v-for="(tag, key) in tags" :key="key">
            <span class="seperator" v-if="key !== 0">|</span>
            <span>{{ tag }}</span>
          </li>
        </ul>
      </div>
    </div>
      
  </div>
</template>
[]
<script>

  export default {
    data () {
      return {
        tags: [
          'Free Inflatable Rides',
          'Live Entertainment',
          'Kids Zone',
          'Food',
          'Fireworks',
        ]
      }
    }
  }

</script>

<style lang="scss">

  #landing {
    padding: 25vh 0;
    margin: 0 auto;
    text-align: center;

    .landing-content {
      text-align: center;
      text-shadow: 0 2px 2px rgba(0, 0, 0, 0.24);
      
      .date {
        font-size: 18px;
        color: #FFF;
        margin: 0 16px;
      }

      .title {
        font-size: 60px;
        color: #FFF;

        @media screen and (max-width: 800px) {
          margin: 60px 0 0;
          font-size: 32px;
        }
      }

      .subtitle {
        font-size: 24px;
        color: #FFF;
        margin: 24px 0 0;
        max-width: 600px;
        padding: 16px;
        margin: 0 auto;

        a {
          color: white;
          text-decoration: underline;
        }

        @media screen and (max-width: 800px) {
          margin: 8px auto 0;
          font-size: 20px;
        }
      }

      
      .text {
        font-size: 16px;
        color: #FFF;
        margin: 24px 0 0;
        max-width: 600px;
        padding: 16px;
        margin: 0 auto;
      }

      .tags {
        margin: 16px 0 0;
        
        @media screen and (max-width: 800px) {
          margin: 40px 0 0;
        }

        ul {
          margin: 0 !important;
          padding: 0 !important;

          li {
            color: #FFF;
            display: inline-block;
            color: #FFF;
            text-transform: uppercase;

            @media screen and (max-width: 800px) {
              display: block;
            }

            span.seperator {
              margin: 0 8px;
              color: #FFF;
            
              @media screen and (max-width: 800px) {
                display: none;
              }

            }
          }

        }
      }

      .downloads {
        margin: 32px 0 0;
        text-shadow: none;

        @media screen and (max-width: 800px) {
          margin: 60px 0 0;
        }

        a {
          padding: 8px;
          margin: 8px;
          text-decoration: none;
          display: inline-block;
          background: rgba(255, 255, 255, .54);
          color: rgba(0, 0, 0, .87);
          border: 1px solid rgba(0, 0, 0, .12);
          font-weight: 600;
          text-transform: uppercase;
          font-size: 14px;
          user-select: none;
          cursor: pointer;
            
          @media screen and (max-width: 800px) {
            display: block;
            width: calc(100% - 32px);
            max-width: 300px;
            margin: 16px auto 0;

          }
      
        }
      }
    }


  }

</style>
